// extracted by mini-css-extract-plugin
export default {"root":"MainLayout_root__ljYwV","topBar":"MainLayout_topBar__qsP5k","bottom":"MainLayout_bottom__HfysG","sideNav":"MainLayout_sideNav__fJIj1","main":"MainLayout_main__oRVW3"};